"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var ItemDetailList = function (_a) {
    var itemDetails = _a.itemDetails;
    var buttonRef = react_1.default.createRef();
    var _b = react_1.default.useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var handleClickDetailButton = function (e) {
        e.stopPropagation();
        setIsModalOpen(true);
    };
    react_1.default.useEffect(function () {
        // 親要素のイベント発火を止めるためにEventListenerでつける
        buttonRef.current && buttonRef.current.addEventListener('click', handleClickDetailButton);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { ref: buttonRef, className: "l-users-estimates-entries-item-list-detail-button l-users-estimates-entries-modal-button" },
            react_1.default.createElement("i", { className: "fa fa-list" }),
            "\u7533\u8FBC\u5185\u5BB9\u8A73\u7D30"),
        react_1.default.createElement(react_responsive_modal_1.default, { open: isModalOpen, onClose: function () { return setIsModalOpen(false); }, classNames: { modal: 'l-users-estimates-entries-modal' } },
            react_1.default.createElement("div", { className: "l-users-estimates-entries-modal-title" }, "\u7533\u3057\u8FBC\u307F\u5185\u5BB9\u8A73\u7D30"),
            react_1.default.createElement("table", { className: "table" },
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, "\u5546\u54C1\u540D"),
                    react_1.default.createElement("th", null, "\u72B6\u614B")),
                itemDetails.map(function (itemDetail, idx) { return (react_1.default.createElement("tr", { key: idx },
                    react_1.default.createElement("td", null, itemDetail.name),
                    react_1.default.createElement("td", null, itemDetail.condition))); })))));
};
exports.default = ItemDetailList;
